import { Link } from "react-router-dom";
import { Building2 } from "lucide-react";
import { INDUSTRIES as INDUSTRIES_TID } from "@/constants/testIds";
import {
  getSortedIndustriesWithCounts,
  formatCompactCount,
} from "@/utils/industryStats";
import { useOpportunities } from "@/hooks/useOpportunities";

export const Industries = () => {
  const { opportunities, industries: industryList } = useOpportunities();
  const industries = getSortedIndustriesWithCounts(industryList, opportunities, { includeEmpty: true });

  return (
    <section
      id="industries"
      data-testid={INDUSTRIES_TID.root}
      className="bg-surface-50"
    >
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-3 lg:gap-16">
          <div className="lg:col-span-1">
            <p className="fursa-eyebrow">Trending Sectors</p>
            <h2 className="fursa-section-title mt-3 font-semibold tracking-tight text-ink-900">
              قطاعات نُتابعها عن قرب
            </h2>
            <p className="mt-4 text-base leading-relaxed text-ink-500">
              نرصد الإشارات في القطاعات ذات النمو والتحوّل السريع في المنطقة العربية، وننتقي منها فرصاً قابلة للتنفيذ.
            </p>
            <Link
              to="/opportunities"
              className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-fursa-700 transition-colors hover:text-fursa-800"
            >
              استكشف كل القطاعات
              <span aria-hidden>←</span>
            </Link>
          </div>

          <div className="lg:col-span-2">
            <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-3">
              {industries.map((ind) => {
                const empty = ind.count === 0;
                return (
                  <Link
                    key={ind.slug}
                    to={`/opportunities?industry=${encodeURIComponent(ind.name)}`}
                    data-testid={INDUSTRIES_TID.item(ind.slug)}
                    aria-label={`عرض ${ind.count} فرصة في ${ind.name}`}
                    className={`group flex items-center justify-between gap-3 rounded-lg border bg-white px-3.5 py-3 transition-all ${
                      empty
                        ? "border-surface-200 opacity-50"
                        : "border-surface-200 hover:-translate-y-0.5 hover:border-fursa-300 hover:bg-fursa-50 hover:shadow-card-hover"
                    }`}
                  >
                    <span className="inline-flex min-w-0 items-center gap-2">
                      <Building2
                        className={`h-3.5 w-3.5 shrink-0 transition-colors ${
                          empty ? "text-ink-500" : "text-ink-500 group-hover:text-fursa-700"
                        }`}
                        strokeWidth={1.75}
                      />
                      <span className="truncate text-sm font-medium text-ink-900">
                        {ind.name}
                      </span>
                    </span>
                    <span
                      dir="ltr"
                      className={`shrink-0 font-mono text-[11px] font-semibold tabular-nums ${
                        empty ? "text-ink-500" : "text-fursa-700"
                      }`}
                    >
                      {formatCompactCount(ind.count)}
                    </span>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
